import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=6de1dd65&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de1dd65",
  null
  
)

export default component.exports